/* eslint-disable sort-imports */
import ContentBlocks from 'app/components/content-blocks';
import JsonLd from 'app/components/partials/json-ld';
import NewsletterStrip from 'app/components/partials/newsletter-strip.container.js';
import NotificationPageSpecific from 'app/components/partials/notification-page-specific.container';
import PropTypes from 'prop-types';
import React from 'react';
import { getEventStructuredData } from 'app/utilities/seo';

const Event = ({ data }) => {
    const { blocks, event } = data;
    const { date, description, mainImage, name: title, price, venues } = event;

    const renderPrice = () => price && (
        <p className="content-detail">
            <span className="price">{price}</span>
        </p>
    );

    const renderVenues = () => venues && (
        <p className="content-detail">
            <span className="location">{venues}</span>
        </p>
    );

    return (
        <div className="content-page">
            <section className="page-banner">
                {mainImage && <img src={mainImage} alt={title} />}
            </section>
            <NotificationPageSpecific type="event" slug={event.slug} />
            <JsonLd data={getEventStructuredData(event)} />
            <section className="content-section || constrain-width medium || centered">
                <span className="h1 condensed">{title}</span>
                <span className="h4 subheading bordered">{date}</span>
                {renderPrice()}
                {renderVenues()}
                <div className="description || rich-editor-content" dangerouslySetInnerHTML={{ __html: description }}></div>
            </section>
            <ContentBlocks data={blocks} pageTitle={title} pageUrl={event.url} />
            <NewsletterStrip pageTitle={title} />
        </div>
    );
};

Event.propTypes = {
    data: PropTypes.object.isRequired
};

export default Event;
